import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AcuityDetails } from '../models/acuity-details.model';
import { AcuityRoomDetails } from '../models/acuity-room-details.model';
import { ConfigService } from './config.service';

@Injectable()
export class AcuityService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/Acuity/";
    }

    async getAcuityDetails(shiftRecordId: number, previousShiftRecordId: number): Promise<AcuityDetails> { 
        shiftRecordId = shiftRecordId ? shiftRecordId : 0;
        previousShiftRecordId = previousShiftRecordId ? previousShiftRecordId : 0;
        
        const params = new HttpParams()
            .set('shiftRecordId', shiftRecordId.toString())
            .set('previousShiftRecordId', previousShiftRecordId.toString());

        return await this._http.get<AcuityDetails>(`${this.apiServer}GetAcuityByShiftRecord`, { params: params }).toPromise<AcuityDetails>();
    }  
    
    async getAcuityRoomDetails(shiftRecordId: number): Promise<AcuityRoomDetails> {
        shiftRecordId = shiftRecordId ? shiftRecordId : 0;

        const params = new HttpParams()
            .set('shiftRecordId', shiftRecordId.toString());

        return await this._http.get<AcuityRoomDetails>(`${this.apiServer}GetAcuityRoomsByShiftRecord`, { params: params }).toPromise<AcuityRoomDetails>();
    }
}